import React from "react";
import { Row, Col, Alert, Card, CardBody, Container, FormFeedback, Input, Label, Form } from "reactstrap";

//redux
import { useSelector, useDispatch } from "react-redux";

import {useState } from "react";
import { Link } from "react-router-dom";
import withRouter from "Components/Common/withRouter";

// Formik Validation
import * as Yup from "yup";
import { useFormik } from "formik";

// action
import { userForgetPassword } from "../../slices/thunk";

// import images
import profile from "../../assets/images/profile-img.png";
import logo from "../../assets/images/darklogo.png";
import { createSelector } from 'reselect';
import axios from "axios";

const ForgetPasswordPage = (props) => {
    const [alertMsgg, setAlertMsgg] = useState<any>({open:false, type:"success", content:'Messages here.', time:'2500'});
    const handleAlertMsggClose = ( event?: React.SyntheticEvent | Event, reason?: string) => {  
        if (reason === "clickaway") { return; }
        setAlertMsgg({ ...alertMsgg, open: false })
    };
    document.title = "Forget Password | BizServe";

    const dispatch = useDispatch<any>();

    const validation = useFormik({
        enableReinitialize: true,

        initialValues: {
            email: '',
        },
        validationSchema: Yup.object({
            email: Yup.string().required("Please Enter Your Email").matches(
                /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                "Please enter a valid email address"
            ),
        }),
        onSubmit: (values) => {
            handleFormSubmit(values)
        }
    });

    const selectProperties = createSelector(
        (state: any) => state.ForgetPassword,
        (forgetPassword) => ({
            forgetError: forgetPassword.forgetError,
            forgetSuccessMsg: forgetPassword.forgetSuccessMsg,
        })
    );

    const validateEmail = (email: string) => {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      return emailRegex.test(email);
    };


    const [isSending, setIsSending] = useState(false);


    const handleFormSubmit = async (values:any) => {
        setIsSending(true);
        try {
            await axios.post("/accounts/forgot_password_user", { email: values.email });
            setAlertMsgg({ ...alertMsgg, open: true, content: "We've sent a password reset link to that email address. Please check your inbox and spam folder.", type: "success" });
            setTimeout(()=>{
                setAlertMsgg({ ...alertMsgg, open: false, content: "", type: "" });
            }, 6000)
        } catch (err:any) {
            if (err.response?.status === 400) {
                setAlertMsgg({ ...alertMsgg, open: true, content: "Please enter a valid email address.", type: "error" });
            } else {
                setAlertMsgg({ ...alertMsgg, open: true, content: "Something went wrong. Please try again later.", type: "error" });
            }
            setTimeout(()=>{
                setAlertMsgg({ ...alertMsgg, open: false, content: "", type: "" });
            }, 5000)
        } finally {
            setIsSending(false);
        }
    };




    const { forgetError, forgetSuccessMsg } = useSelector(selectProperties);

    return (
        <React.Fragment>
            <div className="home-btn d-none d-sm-block">
                <Link to="/" className="text-dark">
                    <i className="bx bx-home h2" />
                </Link>
            </div>
            {alertMsgg.open && (
                <Alert
                    color={alertMsgg.type === "success" ? "success" : "danger"}
                    toggle={handleAlertMsggClose}
                    style={{ fontWeight: "bold" }}
                    fade={false}
                    >
                    {alertMsgg.content}
                </Alert>
            )}
            <div className="account-pages fullpagebg my-md-0 my-5 pt-sm-5">
                <Container>
                    <Row className="justify-content-center">
                        <Col md={8} lg={6} xl={5}>
                            <Card className="overflow-hidden">
                                <div className="bg-primary-subtle bgImgGradient">
                                    <Row>
                                        <Col xs={7}>
                                            <div className="text-dark p-4">
                                                <h5 className="text-dark">Welcome Back !</h5>
                                                <p>Sign in to continue to BizServe.</p>
                                            </div>
                                        </Col>
                                        <Col className="col-5 align-self-end">
                                            <img src={profile} alt="" className="img-fluid" />
                                        </Col>
                                    </Row>
                                </div>
                                <CardBody className="pt-0">
                                    <div>
                                        <Link to="/">
                                            <div className="avatar-md profile-user-wid mb-4">
                                                <span className="avatar-title rounded-circle bg-light">
                                                    <img
                                                        src={logo}
                                                        alt=""
                                                        className=""
                                                        height="38"
                                                    />
                                                </span>
                                            </div>
                                        </Link>
                                    </div>
                                    <div className="p-2">
                                        {forgetError && forgetError ? (
                                            <Alert color="danger" style={{ marginTop: "13px" }}>
                                                {forgetError}
                                            </Alert>
                                        ) : null}
                                        {forgetSuccessMsg ? (
                                            <Alert color="success" style={{ marginTop: "13px" }}>
                                                {forgetSuccessMsg}
                                            </Alert>
                                        ) : null}

                                        <Form
                                            className="form-horizontal"
                                            onSubmit={(e) => {
                                                e.preventDefault();
                                                validation.handleSubmit();
                                                return false;
                                            }}
                                        >
                                            <div className="mb-3">
                                                <Label className="form-label">Email<span className="text-danger px-1">*</span></Label>
                                                <Input
                                                    name="email"
                                                    className="form-control"
                                                    placeholder="Enter email"
                                                    type="email"
                                                    onChange={validation.handleChange}
                                                    onBlur={validation.handleBlur}
                                                    value={validation.values.email || ""}
                                                    invalid={
                                                        validation.touched.email && validation.errors.email ? true : false
                                                    }
                                                />
                                                {validation.touched.email && validation.errors.email ? (
                                                    <FormFeedback type="invalid">{validation.errors.email}</FormFeedback>
                                                ) : null}
                                            </div>
                                            <Row className="mb-3">
                                                <Col className="text-end">
                                                    <button
                                                        className="btn btn-primary w-md "
                                                        type="submit"
                                                        disabled={isSending}
                                                    >
                                                        {isSending ? "Sending..." : "Reset"}
                                                    </button>
                                                </Col>
                                            </Row>
                                        </Form>
                                    </div>
                                </CardBody>
                            </Card>
                            <div className="mt-5 text-center">
                                <p>
                                    Go back to{" "}
                                    <Link to="/login" className="font-weight-medium text-primary">
                                        Login
                                    </Link>{" "}
                                </p>
                                <p>
                                    © {new Date().getFullYear()} BizServe. Crafted with{" "}
                                    <i className="mdi mdi-heart text-danger" /> by BizServe LLC
                                </p>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </div>
        </React.Fragment>
    );
};

export default withRouter(ForgetPasswordPage);